import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Cat, LogOut } from "lucide-react";

export function Header() {
  const { user, logout } = useAuth();
  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-background/80 border-b border-border/50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <div className="h-9 w-9 rounded-full bg-primary flex items-center justify-center">
            <Cat className="h-5 w-5 text-primary-foreground" />
          </div>
          <div className="leading-none">
            <div className="font-serif text-xl font-semibold">AnnieHealth</div>
            <div className="text-[10px] uppercase tracking-wider text-muted-foreground">Wellness Journal</div>
          </div>
        </div>
        <div className="flex items-center gap-4">
          {user && (
            <div className="text-right hidden sm:block">
              <div className="text-sm font-medium" data-testid="header-user-name">{user.name}</div>
              <div className="text-[10px] uppercase tracking-wider text-muted-foreground">{user.role}</div>
            </div>
          )}
          <Button variant="outline" size="sm" className="rounded-full" onClick={logout} data-testid="logout-button">
            <LogOut className="h-4 w-4 mr-1.5" /> Logout
          </Button>
        </div>
      </div>
    </header>
  );
}
